// src/pages/support/components/TeamForm.jsx
import React, { useState } from "react";
import Field from "./Field";

function TeamForm({ initialValues, onSubmit }) {
  const [values, setValues] = useState({
    name: "",
    color: "#10b981",
    logo_path: "",
    status: "active",
    ...(initialValues || {}),
  });

  const [submitting, setSubmitting] = useState(false);
  const [err, setErr] = useState("");

  function setField(k, v) {
    setValues((p) => ({ ...p, [k]: v }));
  }

  function validate() {
    if (!values.name?.trim()) return "نام تیم الزامی است";
    if (!values.color?.trim()) return "رنگ تیم الزامی است";
    return "";
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const v = validate();
    if (v) {
      setErr(v);
      return;
    }
    setErr("");
    setSubmitting(true);
    try {
      const payload = {
        name: values.name.trim(),
        color: values.color,
        logo_path: values.logo_path?.trim() || "",
        ...(values.status ? { status: values.status } : {}),
      };
      await onSubmit(
        payload,
        () => setSubmitting(false),
        (msg) => {
          setSubmitting(false);
          setErr(msg);
        }
      );
    } catch (e) {
      setSubmitting(false);
      setErr(e.message || "خطای نامشخص");
    }
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-4 text-right">
      {err && <div className="text-red-400 text-sm">{err}</div>}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <Field label="نام تیم">
          <input
            value={values.name}
            onChange={(e) => setField("name", e.target.value)}
            className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
            placeholder="مثال: Eagle Hunters"
          />
        </Field>

        <Field label="رنگ تیم (HEX)">
          <div className="flex items-center gap-3">
            <input
              value={values.color}
              onChange={(e) => setField("color", e.target.value)}
              className="flex-1 rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500 ltr"
              placeholder="#10b981"
            />
            <span
              className="w-10 h-10 rounded-lg border"
              style={{ backgroundColor: values.color || "#10b981", borderColor: "rgba(55,65,81,0.6)" }}
              title={values.color}
            />
          </div>
        </Field>

        <Field label="مسیر لوگو (logo_path)">
          <input
            value={values.logo_path}
            onChange={(e) => setField("logo_path", e.target.value)}
            className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500 ltr"
            placeholder="uploads/teams/eagle-hunters.png"
          />
        </Field>

        <Field label="وضعیت">
          <select
            value={values.status}
            onChange={(e) => setField("status", e.target.value)}
            className="w-full rounded-xl bg-gray-800 border border-gray-700 text-gray-200 px-3 py-2 focus:outline-none focus:border-emerald-500"
          >
            <option value="active">فعال</option>
            <option value="inactive">غیرفعال</option>
          </select>
        </Field>
      </div>

      <div className="flex justify-end gap-3 pt-2">
        <button
          type="submit"
          disabled={submitting}
          className={`px-4 py-2 rounded-xl text-white ${submitting ? "opacity-70" : ""}`}
          style={{ backgroundColor: "#10b981" }}
        >
          {submitting ? "در حال ثبت..." : "ثبت"}
        </button>
      </div>
    </form>
  );
}

export default TeamForm;